import React, { PropsWithChildren, ReactNode } from "react";

import { Typography } from "@material-ui/core";

import useActionbarStyle from './action_toolbar.style';

export interface ActionToolbarProps extends PropsWithChildren<any> {
  title: string;
  actions: ReactNode[];
}

function ActionToolbar(props: ActionToolbarProps) {
  const { title, actions, children } = props;
  const classes = useActionbarStyle();

  return (
    <div className={classes.actionToolbar}>
      <Typography variant="h4" className={classes.actionBarTitle}>{title}</Typography>
      {children}
      <div className={classes.actionToolbarActions}>
        {actions}
      </div>
    </div>
  );
}

export { ActionToolbar }